import React, { useContext, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Context as InterestContext } from '../../../../context/InterestContext';
import { useRealTime } from '../../../../context/RealTimeContext';

const InterestCard = ({ setNavTabSelected }) => {
  const {
    state: { interestStatus, loading, interestStatusInitFetchDone },
    fetchInterestStatus,
    setInterestStatusInitFetchDone,
  } = useContext(InterestContext);

  const { lastUpdate } = useRealTime();
  const lastRefreshTimestamp = useRef(null);

  // Fetch interest status on component mount
  useEffect(() => {
    if (!interestStatusInitFetchDone) {
      fetchInterestStatus();
      setInterestStatusInitFetchDone(true);
    }
  }, [
    interestStatusInitFetchDone,
    fetchInterestStatus,
    setInterestStatusInitFetchDone,
  ]);

  // Handle real-time updates
  useEffect(() => {
    if (lastUpdate && lastUpdate.dataType === 'interest') {
      const now = Date.now();
      if (
        lastRefreshTimestamp.current &&
        now - lastRefreshTimestamp.current < 2000
      ) {
        return;
      }

      lastRefreshTimestamp.current = now;
      setTimeout(() => {
        fetchInterestStatus();
      }, 500);
    }
  }, [lastUpdate, fetchInterestStatus]);

  const section = {
    id: 'interest',
    title: 'Interests',
    description: 'Add your personal interests and hobbies',
    icon: '🎯',
    route: '/app/cv-builder/interest',
  };

  return (
    <Link
      to={section.route}
      className="dashboard-section-card"
      onClick={() => setNavTabSelected(section.id)}
    >
      <div className="dashboard-section-icon">{section.icon}</div>
      <div className="dashboard-section-content">
        <h4>{section.title}</h4>
        <p>{section.description}</p>
        {loading && <span className="loading-indicator">Loading...</span>}
        {interestStatus !== null && !loading && (
          <span className="status-indicator">
            {Number(interestStatus) === 0 ? (
              <span style={{ color: '#e74c3c' }}>● 0</span>
            ) : Number(interestStatus) === 1 ? (
              <span style={{ color: '#f39c12' }}>● 1</span>
            ) : Number(interestStatus) === 2 ? (
              <span style={{ color: '#f1c40f' }}>● 2</span>
            ) : (
              <span style={{ color: '#2ecc71' }}>● {interestStatus}</span>
            )}
          </span>
        )}
      </div>
      <div className="dashboard-section-arrow">→</div>
    </Link>
  );
};

export default InterestCard;
